import Typed from 'typed.js'

let mcDetailsInterval
let typedServerName
let typedServerIp

function startTypingMcServerName() {
    if (typedServerName) {
        typedServerName.destroy()
    }
    if (typedServerIp) {
        typedServerIp.destroy()
    }

    typedServerName = new Typed("#typed-server-name", {
        // TODO: Grab this from a config
        strings: ['Risnox'],
        startDelay: 500,
        typeSpeed: 100,
        backDelay: 0,
        showCursor: false,
        loop: false,
        onStringTyped: function () {
            startTypingMcServerIP()
        }
    })
}

function startTypingMcServerIP() {
    typedServerIp = new Typed("#typed-server-ip", {
        // TODO: Grab this from a config
        strings: ["play.risnox.eu"],
        startDelay: 500,
        typeSpeed: 100,
        backDelay: 100,
        showCursor: false,
        loop: false,
        onStringTyped: function () {
            startButtonAnimationMcDetails()
        }
    })
}

function startButtonAnimationMcDetails() {
    let i = 0;
    const btn = document.getElementById("mc-menu-btn-join-server")

    mcDetailsInterval = setInterval(function () {
        if (btn.classList.contains("active")) {
            btn.classList.remove("active");
        } else {
            btn.classList.add("active");
        }

        if (i > 10) {
            clearInterval(mcDetailsInterval);
            startTypingMcServerName();
        } else {
            i++;
        }
    }, 500);
}

startTypingMcServerName()
